import { combineReducers, mergeReducers } from 'redux-merge-immutable-reducers';
import { handleActions, combineActions } from 'redux-actions';
import { fromJS, Map, List } from 'immutable';


import actions from '../actions';
import step from './step';
import filters from './filter';
import corporate from './corporate';
import order_by from './orderBy';
import reservation from './reservation/reservation';
import reservation_request from './reservation/reservationRequest';
import params from '@synergycms_core/store/customer/params';
import { currencies, main_currencies, current_currency } from '@synergycms_core/store/customer/currency';
import loyalty from './loyalty';

//REDUCERS
const {
  langInfo: langActions,
  googleApiKey: googleApiKeyActions,
  webType: webTypeActions,
  availTypeSelected: availTypeSelectedActions,
  currencyCountry: currencyCountryActions,
  currentHotels: currentHotelsActions,
  currentHotel: currentHotelActions,
  selectedHotel: selectedHotelActions,
  transactionId: transactionIdActions,
  roomPreferences: roomPreferencesActions,
  cardMask: cardMaskActions,
  hasCvv: hasCvvActions,
  header: headerActions,
  stripeToken: stripeTokenActions,
  ipCountry: ipCountryActions,
  selectionAvail: selectionAvailActions,
  forcedStep: forcedStepActions
} = actions.customer;

const lang_info = handleActions(
  {
    [langActions.get.toString()]: (langInfo, { payload }) => {
      return fromJS(payload);
    }
  },
  Map()
);

const web_type = handleActions(
  {
    [webTypeActions.get.toString()]: (webType, { payload }) => {
      return payload;
    }
  },
  String()
);

const avail_type_selected = handleActions(
  {
    [availTypeSelectedActions.set.toString()]: (availTypeSelected, { payload }) => {
      return payload;
    }
  }, 
  "loyalty"
);

const google_api_key = handleActions(
  {
    [googleApiKeyActions.get.toString()]: (googleApiKey, { payload }) => {
      return payload;
    }
  },
  Map()
);

const current_hotels = handleActions(
  {
    [currentHotelsActions.set.toString()]: (hotels, { payload }) => {
      return List(payload);
    }
  },
  List()
);

const current_hotel = handleActions(
  {
    [combineActions(currentHotelActions.setId.toString(), currentHotelActions.clearId.toString())]: (
      hotel,
      { payload }
    ) => {
      return payload;
    }
  },
  null
);

const selected_hotel = handleActions(
  {
    [combineActions(selectedHotelActions.set.toString(), selectedHotelActions.clear.toString())]: (
      hotel,
      { payload }
    ) => {
      return payload;
    }
  },
  null
);

const header = handleActions(
  {
    [headerActions.show.toString()]: (header, { payload }) => {
      return header.set(payload.key, payload.show);
    }
  },
  Map({ engine: false, search_options: false })
);

const customer = handleActions(
  {
    [currencyCountryActions.getAsync.toString()]: (customer, { payload }) => {
      return customer
        .set('client_ip', payload.ClientIP)
        .set('country', Map({ code: payload.CountryCode }))
        .set('currency', Map({ code: payload.CurrencyCode }));
    }
  },
  Map()
);

const transaction_id = handleActions(
  {
    [transactionIdActions.set.toString()]: (transactionId, { payload }) => {
      return payload;
    }
  },
  String()
);

const room_preferences = handleActions(
  {
    [roomPreferencesActions.initialize.toString()]: (preferences, { payload }) => {
      return payload;
    }
  },
  List()
);

const card_mask = handleActions(
  {
    [cardMaskActions.getAsync.toString()]: (cardMask, { payload }) => {
      return payload;
    }
  },
  String()
);

const stripe_token = handleActions(
  {
    [stripeTokenActions.getAsync.toString()]: (stripe_token, { payload }) => {
      return payload;
    }
  },
  String()
);

const country_ip = handleActions(
  {
    [ipCountryActions.getAsync.toString()]: (countryIp, { payload }) => {
      return payload;
    }
  },
  String()
);

const has_cvv = handleActions(
  {
    [hasCvvActions.getAsync.toString()]: (has_cvv, { payload }) => {
      return payload;
    }
  },
  Boolean()
);

const selection_avail = handleActions(
  {
    [selectionAvailActions.set.toString()]: (selectionAvail, { payload }) => {
      return payload;
    }
  },
  false
);
const forced_step = handleActions(
  {
    [forcedStepActions.set.toString()]: (forcedStep, { payload }) => {
      return payload;
    }
  },
  false
);

export default mergeReducers(
  customer,
  combineReducers({
    filters,
    order_by,
    corporate,
    params,
    step,
    reservation,
    reservation_request,
    lang_info,
    web_type,
    avail_type_selected,
    google_api_key,
    loyalty,
    currencies,
    main_currencies,
    current_currency,
    current_hotels,
    current_hotel,
    selected_hotel,
    transaction_id,
    room_preferences,
    card_mask,
    has_cvv,
    stripe_token,
    country_ip,
    header,
    selection_avail,
    forced_step
  })
);
